import { CustomerRole } from "@/models/CustomerRole";

const translations = {
	[CustomerRole.Staff]: "Gestão",
	[CustomerRole.Customer]: "Cliente",
};

export const formatCustomerRole = (customerRole: CustomerRole) => translations[customerRole];
